import {
  DeleteBankingPaymentRequestItemDocument,
  PaymentRequestDetailItemsDocument,
  PaymentRequestDetailRoutesDocument,
  PaymentRequestInsightsDocument,
  PaymentRequestItemsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useDeletePaymentRequestItem = () => {
  const [deletePaymentRequestItem, { loading }] = useMutation(
    DeleteBankingPaymentRequestItemDocument,
    {
      extractorFn: (data) => data.bankingMutations.deleteBankingPaymentRequestItem,
      refetchQueries: [
        PaymentRequestItemsDataCollectionDocument,
        PaymentRequestDetailItemsDocument,
        PaymentRequestDetailRoutesDocument,
        PaymentRequestInsightsDocument,
      ],
      awaitRefetchQueries: true,
    }
  )

  const submitDeleteItem = async ({ id }: { id: number }) => {
    const result = await deletePaymentRequestItem({
      variables: { id },
    })
    const handled = handleResult(result, () => {})
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('banking.paymentRequests.deleted_item'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    }
    return handled
  }

  return {
    submitDeleteItem,
    loading,
  }
}
